import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AnalyticsResponseTimesComponent } from './analytics-response-times.component';

const routes: Routes = [
  {
    path: '',
    component: AnalyticsResponseTimesComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AnalyticsResponseTimesRoutingModule {}
